/**
 * Directional tilt left gesture
 * @module gestures/transforms/tiltLeft
 */
import { createTiltGesture } from './tiltFactory.js';
export default createTiltGesture('left');
